var cov_uv2rop2ev = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/element.tsx",
      hash = "51f5f38de7f062f888bfeabc76603a24ec51c578",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/element.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 23
        }
      },
      "2": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 17,
          column: 31
        }
      },
      "3": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 15
        }
      },
      "5": {
        start: {
          line: 25,
          column: 43
        },
        end: {
          line: 25,
          column: 45
        }
      },
      "6": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 36,
          column: 3
        }
      },
      "7": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "8": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 30,
          column: 7
        }
      },
      "9": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 19
        }
      },
      "10": {
        start: {
          line: 31,
          column: 11
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "11": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 17
        }
      },
      "12": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 29
        }
      },
      "13": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 13
        }
      },
      "14": {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 41,
          column: 69
        }
      },
      "15": {
        start: {
          line: 41,
          column: 37
        },
        end: {
          line: 41,
          column: 69
        }
      },
      "16": {
        start: {
          line: 42,
          column: 14
        },
        end: {
          line: 42,
          column: 17
        }
      },
      "17": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 45,
          column: 32
        }
      },
      "18": {
        start: {
          line: 45,
          column: 17
        },
        end: {
          line: 45,
          column: 32
        }
      },
      "19": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 52,
          column: 4
        }
      },
      "20": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      "21": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 92
        }
      },
      "22": {
        start: {
          line: 48,
          column: 44
        },
        end: {
          line: 48,
          column: 92
        }
      },
      "23": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 32
        }
      },
      "24": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 15
        }
      },
      "25": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 56,
          column: 19
        }
      },
      "26": {
        start: {
          line: 56,
          column: 13
        },
        end: {
          line: 56,
          column: 19
        }
      },
      "27": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 63,
          column: 3
        }
      },
      "28": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 79
        }
      },
      "29": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 46
        }
      },
      "30": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 37
        }
      },
      "31": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 27
        }
      },
      "32": {
        start: {
          line: 68,
          column: 18
        },
        end: {
          line: 68,
          column: 47
        }
      },
      "33": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 75,
          column: 3
        }
      },
      "34": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      "35": {
        start: {
          line: 71,
          column: 20
        },
        end: {
          line: 71,
          column: 39
        }
      },
      "36": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 55
        }
      },
      "37": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 40
        }
      },
      "38": {
        start: {
          line: 76,
          column: 2
        },
        end: {
          line: 76,
          column: 14
        }
      },
      "39": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 80,
          column: 22
        }
      },
      "40": {
        start: {
          line: 80,
          column: 11
        },
        end: {
          line: 80,
          column: 22
        }
      },
      "41": {
        start: {
          line: 81,
          column: 15
        },
        end: {
          line: 81,
          column: 41
        }
      },
      "42": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 91,
          column: 3
        }
      },
      "43": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 103,
          column: 3
        }
      },
      "44": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 46
        }
      },
      "45": {
        start: {
          line: 104,
          column: 2
        },
        end: {
          line: 108,
          column: 3
        }
      },
      "46": {
        start: {
          line: 105,
          column: 18
        },
        end: {
          line: 105,
          column: 66
        }
      },
      "47": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 41
        }
      },
      "48": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 28
        }
      },
      "49": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 109,
          column: 13
        }
      },
      "50": {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 113,
          column: 22
        }
      },
      "51": {
        start: {
          line: 113,
          column: 16
        },
        end: {
          line: 113,
          column: 22
        }
      },
      "52": {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 114,
          column: 17
        }
      },
      "53": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "54": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 31
        }
      },
      "55": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 10
        }
      },
      "56": {
        start: {
          line: 119,
          column: 2
        },
        end: {
          line: 130,
          column: 3
        }
      },
      "57": {
        start: {
          line: 120,
          column: 18
        },
        end: {
          line: 120,
          column: 39
        }
      },
      "58": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "59": {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 122,
          column: 38
        }
      },
      "60": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 123,
          column: 27
        }
      },
      "61": {
        start: {
          line: 125,
          column: 9
        },
        end: {
          line: 130,
          column: 3
        }
      },
      "62": {
        start: {
          line: 126,
          column: 18
        },
        end: {
          line: 126,
          column: 66
        }
      },
      "63": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 36
        }
      },
      "64": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 25
        }
      },
      "65": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 18
        }
      },
      "66": {
        start: {
          line: 134,
          column: 2
        },
        end: {
          line: 137,
          column: 3
        }
      },
      "67": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 19
        }
      },
      "68": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 10
        }
      },
      "69": {
        start: {
          line: 138,
          column: 2
        },
        end: {
          line: 151,
          column: 3
        }
      },
      "70": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 32
        }
      },
      "71": {
        start: {
          line: 139,
          column: 17
        },
        end: {
          line: 139,
          column: 32
        }
      },
      "72": {
        start: {
          line: 140,
          column: 18
        },
        end: {
          line: 140,
          column: 40
        }
      },
      "73": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 50
        }
      },
      "74": {
        start: {
          line: 141,
          column: 17
        },
        end: {
          line: 141,
          column: 50
        }
      },
      "75": {
        start: {
          line: 142,
          column: 16
        },
        end: {
          line: 142,
          column: 37
        }
      },
      "76": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 146,
          column: 5
        }
      },
      "77": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 27
        }
      },
      "78": {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 145,
          column: 25
        }
      },
      "79": {
        start: {
          line: 147,
          column: 9
        },
        end: {
          line: 151,
          column: 3
        }
      },
      "80": {
        start: {
          line: 148,
          column: 18
        },
        end: {
          line: 148,
          column: 66
        }
      },
      "81": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 36
        }
      },
      "82": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 18
        }
      },
      "83": {
        start: {
          line: 154,
          column: 28
        },
        end: {
          line: 159,
          column: 1
        }
      },
      "84": {
        start: {
          line: 165,
          column: 32
        },
        end: {
          line: 184,
          column: 1
        }
      },
      "85": {
        start: {
          line: 170,
          column: 13
        },
        end: {
          line: 170,
          column: 103
        }
      },
      "86": {
        start: {
          line: 172,
          column: 2
        },
        end: {
          line: 178,
          column: 3
        }
      },
      "87": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 177,
          column: 5
        }
      },
      "88": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 174,
          column: 61
        }
      },
      "89": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 176,
          column: 56
        }
      },
      "90": {
        start: {
          line: 179,
          column: 2
        },
        end: {
          line: 179,
          column: 20
        }
      },
      "91": {
        start: {
          line: 180,
          column: 2
        },
        end: {
          line: 182,
          column: 3
        }
      },
      "92": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 181,
          column: 23
        }
      },
      "93": {
        start: {
          line: 183,
          column: 2
        },
        end: {
          line: 183,
          column: 49
        }
      },
      "94": {
        start: {
          line: 186,
          column: 31
        },
        end: {
          line: 186,
          column: 83
        }
      },
      "95": {
        start: {
          line: 186,
          column: 48
        },
        end: {
          line: 186,
          column: 83
        }
      },
      "96": {
        start: {
          line: 195,
          column: 33
        },
        end: {
          line: 237,
          column: 1
        }
      },
      "97": {
        start: {
          line: 196,
          column: 31
        },
        end: {
          line: 196,
          column: 38
        }
      },
      "98": {
        start: {
          line: 197,
          column: 40
        },
        end: {
          line: 197,
          column: 64
        }
      },
      "99": {
        start: {
          line: 198,
          column: 10
        },
        end: {
          line: 198,
          column: 25
        }
      },
      "100": {
        start: {
          line: 201,
          column: 2
        },
        end: {
          line: 231,
          column: 3
        }
      },
      "101": {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 221,
          column: 5
        }
      },
      "102": {
        start: {
          line: 203,
          column: 6
        },
        end: {
          line: 203,
          column: 32
        }
      },
      "103": {
        start: {
          line: 204,
          column: 6
        },
        end: {
          line: 204,
          column: 34
        }
      },
      "104": {
        start: {
          line: 205,
          column: 6
        },
        end: {
          line: 220,
          column: 7
        }
      },
      "105": {
        start: {
          line: 206,
          column: 34
        },
        end: {
          line: 206,
          column: 54
        }
      },
      "106": {
        start: {
          line: 207,
          column: 8
        },
        end: {
          line: 217,
          column: 9
        }
      },
      "107": {
        start: {
          line: 208,
          column: 10
        },
        end: {
          line: 210,
          column: 11
        }
      },
      "108": {
        start: {
          line: 209,
          column: 12
        },
        end: {
          line: 209,
          column: 34
        }
      },
      "109": {
        start: {
          line: 211,
          column: 15
        },
        end: {
          line: 217,
          column: 9
        }
      },
      "110": {
        start: {
          line: 212,
          column: 10
        },
        end: {
          line: 214,
          column: 11
        }
      },
      "111": {
        start: {
          line: 213,
          column: 12
        },
        end: {
          line: 213,
          column: 34
        }
      },
      "112": {
        start: {
          line: 215,
          column: 15
        },
        end: {
          line: 217,
          column: 9
        }
      },
      "113": {
        start: {
          line: 216,
          column: 10
        },
        end: {
          line: 216,
          column: 86
        }
      },
      "114": {
        start: {
          line: 218,
          column: 8
        },
        end: {
          line: 218,
          column: 25
        }
      },
      "115": {
        start: {
          line: 219,
          column: 8
        },
        end: {
          line: 219,
          column: 27
        }
      },
      "116": {
        start: {
          line: 222,
          column: 42
        },
        end: {
          line: 222,
          column: 89
        }
      },
      "117": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 223,
          column: 24
        }
      },
      "118": {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 230,
          column: 5
        }
      },
      "119": {
        start: {
          line: 225,
          column: 6
        },
        end: {
          line: 227,
          column: 7
        }
      },
      "120": {
        start: {
          line: 226,
          column: 8
        },
        end: {
          line: 226,
          column: 29
        }
      },
      "121": {
        start: {
          line: 228,
          column: 6
        },
        end: {
          line: 228,
          column: 22
        }
      },
      "122": {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 229,
          column: 21
        }
      },
      "123": {
        start: {
          line: 232,
          column: 2
        },
        end: {
          line: 232,
          column: 63
        }
      },
      "124": {
        start: {
          line: 233,
          column: 2
        },
        end: {
          line: 236,
          column: 3
        }
      },
      "125": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 49
        }
      },
      "126": {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 235,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "getParent",
        decl: {
          start: {
            line: 20,
            column: 16
          },
          end: {
            line: 20,
            column: 25
          }
        },
        loc: {
          start: {
            line: 20,
            column: 91
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 41,
            column: 20
          },
          end: {
            line: 41,
            column: 21
          }
        },
        loc: {
          start: {
            line: 41,
            column: 37
          },
          end: {
            line: 41,
            column: 69
          }
        },
        line: 41
      },
      "2": {
        name: "wrapSpan",
        decl: {
          start: {
            line: 44,
            column: 16
          },
          end: {
            line: 44,
            column: 24
          }
        },
        loc: {
          start: {
            line: 44,
            column: 72
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 46,
            column: 38
          },
          end: {
            line: 46,
            column: 39
          }
        },
        loc: {
          start: {
            line: 46,
            column: 46
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 46
      },
      "4": {
        name: "dispatchEvent",
        decl: {
          start: {
            line: 55,
            column: 16
          },
          end: {
            line: 55,
            column: 29
          }
        },
        loc: {
          start: {
            line: 55,
            column: 80
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 55
      },
      "5": {
        name: "cssSupport",
        decl: {
          start: {
            line: 67,
            column: 16
          },
          end: {
            line: 67,
            column: 26
          }
        },
        loc: {
          start: {
            line: 67,
            column: 75
          },
          end: {
            line: 77,
            column: 1
          }
        },
        line: 67
      },
      "6": {
        name: "copyBoundingClientRect",
        decl: {
          start: {
            line: 79,
            column: 16
          },
          end: {
            line: 79,
            column: 38
          }
        },
        loc: {
          start: {
            line: 79,
            column: 56
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 79
      },
      "7": {
        name: "getCursorOffset",
        decl: {
          start: {
            line: 100,
            column: 16
          },
          end: {
            line: 100,
            column: 31
          }
        },
        loc: {
          start: {
            line: 100,
            column: 48
          },
          end: {
            line: 110,
            column: 1
          }
        },
        line: 100
      },
      "8": {
        name: "end",
        decl: {
          start: {
            line: 112,
            column: 9
          },
          end: {
            line: 112,
            column: 12
          }
        },
        loc: {
          start: {
            line: 112,
            column: 78
          },
          end: {
            line: 131,
            column: 1
          }
        },
        line: 112
      },
      "9": {
        name: "select",
        decl: {
          start: {
            line: 133,
            column: 9
          },
          end: {
            line: 133,
            column: 15
          }
        },
        loc: {
          start: {
            line: 133,
            column: 38
          },
          end: {
            line: 152,
            column: 1
          }
        },
        line: 133
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 165,
            column: 32
          },
          end: {
            line: 165,
            column: 33
          }
        },
        loc: {
          start: {
            line: 169,
            column: 5
          },
          end: {
            line: 184,
            column: 1
          }
        },
        line: 169
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 186,
            column: 31
          },
          end: {
            line: 186,
            column: 32
          }
        },
        loc: {
          start: {
            line: 186,
            column: 48
          },
          end: {
            line: 186,
            column: 83
          }
        },
        line: 186
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 195,
            column: 33
          },
          end: {
            line: 195,
            column: 34
          }
        },
        loc: {
          start: {
            line: 195,
            column: 96
          },
          end: {
            line: 237,
            column: 1
          }
        },
        line: 195
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 205,
            column: 10
          },
          end: {
            line: 205,
            column: 11
          }
        },
        loc: {
          start: {
            line: 205,
            column: 75
          },
          end: {
            line: 220,
            column: 7
          }
        },
        line: 205
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 224,
            column: 11
          },
          end: {
            line: 224,
            column: 12
          }
        },
        loc: {
          start: {
            line: 224,
            column: 17
          },
          end: {
            line: 230,
            column: 5
          }
        },
        line: 224
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 233,
            column: 9
          },
          end: {
            line: 233,
            column: 10
          }
        },
        loc: {
          start: {
            line: 233,
            column: 15
          },
          end: {
            line: 236,
            column: 3
          }
        },
        line: 233
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 0
          },
          end: {
            line: 18,
            column: 1
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4,
            column: 0
          },
          end: {
            line: 18,
            column: 1
          }
        }, {
          start: {
            line: 4,
            column: 0
          },
          end: {
            line: 18,
            column: 1
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 4,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 4,
            column: 11
          }
        }, {
          start: {
            line: 4,
            column: 15
          },
          end: {
            line: 4,
            column: 41
          }
        }],
        line: 4
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 17,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 13,
            column: 25
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 14,
            column: 28
          }
        }, {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 27
          }
        }, {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 26
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 17,
            column: 31
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }, {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }],
        line: 21
      },
      "4": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }],
        line: 27
      },
      "5": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        }, {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        }],
        line: 28
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 10
          },
          end: {
            line: 28,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 10
          },
          end: {
            line: 28,
            column: 22
          }
        }, {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 28,
            column: 46
          }
        }],
        line: 28
      },
      "7": {
        loc: {
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 33,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 33,
            column: 5
          }
        }, {
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 33,
            column: 5
          }
        }],
        line: 31
      },
      "8": {
        loc: {
          start: {
            line: 44,
            column: 46
          },
          end: {
            line: 44,
            column: 65
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 44,
            column: 60
          },
          end: {
            line: 44,
            column: 65
          }
        }],
        line: 44
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 32
          }
        }, {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 32
          }
        }],
        line: 45
      },
      "10": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }],
        line: 47
      },
      "11": {
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 92
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 92
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 92
          }
        }],
        line: 48
      },
      "12": {
        loc: {
          start: {
            line: 48,
            column: 10
          },
          end: {
            line: 48,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 10
          },
          end: {
            line: 48,
            column: 21
          }
        }, {
          start: {
            line: 48,
            column: 25
          },
          end: {
            line: 48,
            column: 42
          }
        }],
        line: 48
      },
      "13": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 19
          }
        }, {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 19
          }
        }],
        line: 56
      },
      "14": {
        loc: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }, {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }],
        line: 58
      },
      "15": {
        loc: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        }, {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        }],
        line: 69
      },
      "16": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        }],
        line: 70
      },
      "17": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 25
          }
        }, {
          start: {
            line: 70,
            column: 29
          },
          end: {
            line: 70,
            column: 50
          }
        }],
        line: 70
      },
      "18": {
        loc: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 22
          }
        }, {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 22
          }
        }],
        line: 80
      },
      "19": {
        loc: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        }, {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        }],
        line: 101
      },
      "20": {
        loc: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        }, {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        }],
        line: 104
      },
      "21": {
        loc: {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 22
          }
        }, {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 22
          }
        }],
        line: 113
      },
      "22": {
        loc: {
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        }, {
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        }],
        line: 115
      },
      "23": {
        loc: {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 115,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 115,
            column: 33
          }
        }, {
          start: {
            line: 115,
            column: 37
          },
          end: {
            line: 115,
            column: 67
          }
        }],
        line: 115
      },
      "24": {
        loc: {
          start: {
            line: 119,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        }, {
          start: {
            line: 119,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        }],
        line: 119
      },
      "25": {
        loc: {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        }, {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        }],
        line: 121
      },
      "26": {
        loc: {
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 130,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 130,
            column: 3
          }
        }, {
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 130,
            column: 3
          }
        }],
        line: 125
      },
      "27": {
        loc: {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        }, {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        }],
        line: 134
      },
      "28": {
        loc: {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 134,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 134,
            column: 13
          }
        }, {
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 134,
            column: 34
          }
        }, {
          start: {
            line: 134,
            column: 38
          },
          end: {
            line: 134,
            column: 68
          }
        }],
        line: 134
      },
      "29": {
        loc: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        }, {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        }],
        line: 138
      },
      "30": {
        loc: {
          start: {
            line: 138,
            column: 6
          },
          end: {
            line: 138,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 6
          },
          end: {
            line: 138,
            column: 25
          }
        }, {
          start: {
            line: 138,
            column: 29
          },
          end: {
            line: 138,
            column: 49
          }
        }],
        line: 138
      },
      "31": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 32
          }
        }, {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 32
          }
        }],
        line: 139
      },
      "32": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 50
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 50
          }
        }],
        line: 141
      },
      "33": {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 146,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 146,
            column: 5
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 146,
            column: 5
          }
        }],
        line: 143
      },
      "34": {
        loc: {
          start: {
            line: 147,
            column: 9
          },
          end: {
            line: 151,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 9
          },
          end: {
            line: 151,
            column: 3
          }
        }, {
          start: {
            line: 147,
            column: 9
          },
          end: {
            line: 151,
            column: 3
          }
        }],
        line: 147
      },
      "35": {
        loc: {
          start: {
            line: 168,
            column: 2
          },
          end: {
            line: 168,
            column: 104
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 168,
            column: 102
          },
          end: {
            line: 168,
            column: 104
          }
        }],
        line: 168
      },
      "36": {
        loc: {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 168,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 168,
            column: 18
          },
          end: {
            line: 168,
            column: 22
          }
        }],
        line: 168
      },
      "37": {
        loc: {
          start: {
            line: 168,
            column: 24
          },
          end: {
            line: 168,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 168,
            column: 36
          },
          end: {
            line: 168,
            column: 39
          }
        }],
        line: 168
      },
      "38": {
        loc: {
          start: {
            line: 170,
            column: 14
          },
          end: {
            line: 170,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 14
          },
          end: {
            line: 170,
            column: 29
          }
        }, {
          start: {
            line: 170,
            column: 33
          },
          end: {
            line: 170,
            column: 80
          }
        }],
        line: 170
      },
      "39": {
        loc: {
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 178,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 178,
            column: 3
          }
        }, {
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 178,
            column: 3
          }
        }],
        line: 172
      },
      "40": {
        loc: {
          start: {
            line: 172,
            column: 6
          },
          end: {
            line: 172,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 6
          },
          end: {
            line: 172,
            column: 17
          }
        }, {
          start: {
            line: 172,
            column: 21
          },
          end: {
            line: 172,
            column: 25
          }
        }],
        line: 172
      },
      "41": {
        loc: {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 177,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 177,
            column: 5
          }
        }, {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 177,
            column: 5
          }
        }],
        line: 173
      },
      "42": {
        loc: {
          start: {
            line: 180,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 180,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        }, {
          start: {
            line: 180,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        }],
        line: 180
      },
      "43": {
        loc: {
          start: {
            line: 195,
            column: 65
          },
          end: {
            line: 195,
            column: 91
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 195,
            column: 89
          },
          end: {
            line: 195,
            column: 91
          }
        }],
        line: 195
      },
      "44": {
        loc: {
          start: {
            line: 201,
            column: 2
          },
          end: {
            line: 231,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 2
          },
          end: {
            line: 231,
            column: 3
          }
        }, {
          start: {
            line: 201,
            column: 2
          },
          end: {
            line: 231,
            column: 3
          }
        }],
        line: 201
      },
      "45": {
        loc: {
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        }, {
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        }],
        line: 202
      },
      "46": {
        loc: {
          start: {
            line: 207,
            column: 8
          },
          end: {
            line: 217,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 207,
            column: 8
          },
          end: {
            line: 217,
            column: 9
          }
        }, {
          start: {
            line: 207,
            column: 8
          },
          end: {
            line: 217,
            column: 9
          }
        }],
        line: 207
      },
      "47": {
        loc: {
          start: {
            line: 207,
            column: 12
          },
          end: {
            line: 207,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 207,
            column: 12
          },
          end: {
            line: 207,
            column: 17
          }
        }, {
          start: {
            line: 207,
            column: 21
          },
          end: {
            line: 207,
            column: 38
          }
        }],
        line: 207
      },
      "48": {
        loc: {
          start: {
            line: 208,
            column: 10
          },
          end: {
            line: 210,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 208,
            column: 10
          },
          end: {
            line: 210,
            column: 11
          }
        }, {
          start: {
            line: 208,
            column: 10
          },
          end: {
            line: 210,
            column: 11
          }
        }],
        line: 208
      },
      "49": {
        loc: {
          start: {
            line: 211,
            column: 15
          },
          end: {
            line: 217,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 211,
            column: 15
          },
          end: {
            line: 217,
            column: 9
          }
        }, {
          start: {
            line: 211,
            column: 15
          },
          end: {
            line: 217,
            column: 9
          }
        }],
        line: 211
      },
      "50": {
        loc: {
          start: {
            line: 212,
            column: 10
          },
          end: {
            line: 214,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 212,
            column: 10
          },
          end: {
            line: 214,
            column: 11
          }
        }, {
          start: {
            line: 212,
            column: 10
          },
          end: {
            line: 214,
            column: 11
          }
        }],
        line: 212
      },
      "51": {
        loc: {
          start: {
            line: 212,
            column: 14
          },
          end: {
            line: 212,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 212,
            column: 14
          },
          end: {
            line: 212,
            column: 20
          }
        }, {
          start: {
            line: 212,
            column: 24
          },
          end: {
            line: 212,
            column: 45
          }
        }],
        line: 212
      },
      "52": {
        loc: {
          start: {
            line: 215,
            column: 15
          },
          end: {
            line: 217,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 15
          },
          end: {
            line: 217,
            column: 9
          }
        }, {
          start: {
            line: 215,
            column: 15
          },
          end: {
            line: 217,
            column: 9
          }
        }],
        line: 215
      },
      "53": {
        loc: {
          start: {
            line: 215,
            column: 19
          },
          end: {
            line: 215,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 215,
            column: 19
          },
          end: {
            line: 215,
            column: 24
          }
        }, {
          start: {
            line: 215,
            column: 28
          },
          end: {
            line: 215,
            column: 34
          }
        }],
        line: 215
      },
      "54": {
        loc: {
          start: {
            line: 225,
            column: 6
          },
          end: {
            line: 227,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 6
          },
          end: {
            line: 227,
            column: 7
          }
        }, {
          start: {
            line: 225,
            column: 6
          },
          end: {
            line: 227,
            column: 7
          }
        }],
        line: 225
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0],
      "36": [0],
      "37": [0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/utils/dom/element.tsx",
    _this2 = this;

import React from 'react';
import { throttle } from '../func';
cov_uv2rop2ev.s[0]++;

if ((cov_uv2rop2ev.b[1][0]++, Element) && (cov_uv2rop2ev.b[1][1]++, !Element.prototype.matches)) {
  cov_uv2rop2ev.b[0][0]++;
  var proto = (cov_uv2rop2ev.s[1]++, Element.prototype);
  cov_uv2rop2ev.s[2]++;
  proto.matches = (cov_uv2rop2ev.b[2][0]++, proto.matchesSelector) || (cov_uv2rop2ev.b[2][1]++, proto.mozMatchesSelector) || (cov_uv2rop2ev.b[2][2]++, proto.msMatchesSelector) || (cov_uv2rop2ev.b[2][3]++, proto.oMatchesSelector) || (cov_uv2rop2ev.b[2][4]++, proto.webkitMatchesSelector);
} else {
  cov_uv2rop2ev.b[0][1]++;
}

export function getParent(el, target) {
  cov_uv2rop2ev.f[0]++;
  cov_uv2rop2ev.s[3]++;

  if (!target) {
    cov_uv2rop2ev.b[3][0]++;
    cov_uv2rop2ev.s[4]++;
    return null;
  } else {
    cov_uv2rop2ev.b[3][1]++;
  }

  var temp = (cov_uv2rop2ev.s[5]++, el);
  cov_uv2rop2ev.s[6]++;

  while (temp) {
    cov_uv2rop2ev.s[7]++;

    if (typeof target === 'string') {
      cov_uv2rop2ev.b[4][0]++;
      cov_uv2rop2ev.s[8]++;

      if ((cov_uv2rop2ev.b[6][0]++, temp.matches) && (cov_uv2rop2ev.b[6][1]++, temp.matches(target))) {
        cov_uv2rop2ev.b[5][0]++;
        cov_uv2rop2ev.s[9]++;
        return temp;
      } else {
        cov_uv2rop2ev.b[5][1]++;
      }
    } else {
      cov_uv2rop2ev.b[4][1]++;
      cov_uv2rop2ev.s[10]++;

      if (temp === target) {
        cov_uv2rop2ev.b[7][0]++;
        cov_uv2rop2ev.s[11]++;
        return temp;
      } else {
        cov_uv2rop2ev.b[7][1]++;
      }
    }

    cov_uv2rop2ev.s[12]++;
    temp = temp.parentElement;
  }

  cov_uv2rop2ev.s[13]++;
  return null;
}
cov_uv2rop2ev.s[14]++;

var isTwoCNChar = function isTwoCNChar(str) {
  cov_uv2rop2ev.f[1]++;
  cov_uv2rop2ev.s[15]++;
  return /^[\u4e00-\u9fa5]{2}$/.test(str);
};

var SPACE = (cov_uv2rop2ev.s[16]++, ' ');
export function wrapSpan(children) {
  var _this = this;

  var insertSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_uv2rop2ev.b[8][0]++, false);
  cov_uv2rop2ev.f[2]++;
  cov_uv2rop2ev.s[17]++;

  if (!children) {
    cov_uv2rop2ev.b[9][0]++;
    cov_uv2rop2ev.s[18]++;
    return children;
  } else {
    cov_uv2rop2ev.b[9][1]++;
  }

  cov_uv2rop2ev.s[19]++;
  return React.Children.map(children, function (item) {
    cov_uv2rop2ev.f[3]++;
    cov_uv2rop2ev.s[20]++;

    if (typeof item === 'string') {
      cov_uv2rop2ev.b[10][0]++;
      cov_uv2rop2ev.s[21]++;

      if ((cov_uv2rop2ev.b[12][0]++, insertSpace) && (cov_uv2rop2ev.b[12][1]++, isTwoCNChar(item))) {
        cov_uv2rop2ev.b[11][0]++;
        cov_uv2rop2ev.s[22]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 48,
              columnNumber: 52
            }
          }, item.split('').join(SPACE))
        );
      } else {
        cov_uv2rop2ev.b[11][1]++;
      }

      cov_uv2rop2ev.s[23]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49,
            columnNumber: 14
          }
        }, item)
      );
    } else {
      cov_uv2rop2ev.b[10][1]++;
    }

    cov_uv2rop2ev.s[24]++;
    return item;
  });
}
export function dispatchEvent(form, name, detail) {
  cov_uv2rop2ev.f[4]++;
  cov_uv2rop2ev.s[25]++;

  if (!form) {
    cov_uv2rop2ev.b[13][0]++;
    cov_uv2rop2ev.s[26]++;
    return;
  } else {
    cov_uv2rop2ev.b[13][1]++;
  }

  var event;
  cov_uv2rop2ev.s[27]++;

  if (CustomEvent) {
    cov_uv2rop2ev.b[14][0]++;
    cov_uv2rop2ev.s[28]++;
    event = new CustomEvent(name, {
      bubbles: false,
      cancelable: true,
      detail: detail
    });
  } else {
    cov_uv2rop2ev.b[14][1]++;
    cov_uv2rop2ev.s[29]++;
    event = document.createEvent('HTMLEvents');
    cov_uv2rop2ev.s[30]++;
    event.initEvent(name, true, true);
  }

  cov_uv2rop2ev.s[31]++;
  form.dispatchEvent(event);
}
export function cssSupport(attr, value) {
  cov_uv2rop2ev.f[5]++;
  var element = (cov_uv2rop2ev.s[32]++, document.createElement('div'));
  cov_uv2rop2ev.s[33]++;

  if (attr in element.style) {
    cov_uv2rop2ev.b[15][0]++;
    cov_uv2rop2ev.s[34]++;

    if ((cov_uv2rop2ev.b[17][0]++, attr !== 'length') && (cov_uv2rop2ev.b[17][1]++, attr !== 'parentRule')) {
      cov_uv2rop2ev.b[16][0]++;
      var attrs = (cov_uv2rop2ev.s[35]++, element.style[attr]);
      cov_uv2rop2ev.s[36]++;
      element.style[attr] = value;
    } else {
      cov_uv2rop2ev.b[16][1]++;
    }

    cov_uv2rop2ev.s[37]++;
    return element.style[attr] === value;
  } else {
    cov_uv2rop2ev.b[15][1]++;
  }

  cov_uv2rop2ev.s[38]++;
  return false;
}
export function copyBoundingClientRect(el) {
  cov_uv2rop2ev.f[6]++;
  cov_uv2rop2ev.s[39]++;

  if (!el) {
    cov_uv2rop2ev.b[18][0]++;
    cov_uv2rop2ev.s[40]++;
    return null;
  } else {
    cov_uv2rop2ev.b[18][1]++;
  }

  var rect = (cov_uv2rop2ev.s[41]++, el.getBoundingClientRect());
  cov_uv2rop2ev.s[42]++;
  return {
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    width: rect.width,
    height: rect.height,
    x: rect.x,
    y: rect.y
  };
}
export function getCursorOffset(length) {
  cov_uv2rop2ev.f[7]++;
  cov_uv2rop2ev.s[43]++;

  if (window.getSelection) {
    cov_uv2rop2ev.b[19][0]++;
    cov_uv2rop2ev.s[44]++;
    return window.getSelection().anchorOffset;
  } else {
    cov_uv2rop2ev.b[19][1]++;
  }

  cov_uv2rop2ev.s[45]++;

  if (document.selection) {
    cov_uv2rop2ev.b[20][0]++;
    var range = (cov_uv2rop2ev.s[46]++, document.selection.createRange());
    cov_uv2rop2ev.s[47]++;
    range.moveStart('character', -length);
    cov_uv2rop2ev.s[48]++;
    return range.text.length;
  } else {
    cov_uv2rop2ev.b[20][1]++;
  }

  cov_uv2rop2ev.s[49]++;
  return null;
}

function end(element) {
  cov_uv2rop2ev.f[8]++;
  cov_uv2rop2ev.s[50]++;

  if (!element) {
    cov_uv2rop2ev.b[21][0]++;
    cov_uv2rop2ev.s[51]++;
    return;
  } else {
    cov_uv2rop2ev.b[21][1]++;
  }

  cov_uv2rop2ev.s[52]++;
  element.focus();
  cov_uv2rop2ev.s[53]++;

  if ((cov_uv2rop2ev.b[23][0]++, element.tagName === 'INPUT') || (cov_uv2rop2ev.b[23][1]++, element.tagName === 'TEXTAREA')) {
    cov_uv2rop2ev.b[22][0]++;
    cov_uv2rop2ev.s[54]++;
    element.selectionStart = -1;
    cov_uv2rop2ev.s[55]++;
    return;
  } else {
    cov_uv2rop2ev.b[22][1]++;
  }

  cov_uv2rop2ev.s[56]++;

  if (window.getSelection) {
    cov_uv2rop2ev.b[24][0]++;
    var range = (cov_uv2rop2ev.s[57]++, window.getSelection());
    cov_uv2rop2ev.s[58]++;

    if (range) {
      cov_uv2rop2ev.b[25][0]++;
      cov_uv2rop2ev.s[59]++;
      range.selectAllChildren(element);
      cov_uv2rop2ev.s[60]++;
      range.collapseToEnd();
    } else {
      cov_uv2rop2ev.b[25][1]++;
    }
  } else {
    cov_uv2rop2ev.b[24][1]++;
    cov_uv2rop2ev.s[61]++;

    if (document.selection) {
      cov_uv2rop2ev.b[26][0]++;

      var _range = (cov_uv2rop2ev.s[62]++, document.selection.createRange());

      cov_uv2rop2ev.s[63]++;

      _range.moveToElementText(element);

      cov_uv2rop2ev.s[64]++;

      _range.collapse(false);

      cov_uv2rop2ev.s[65]++;

      _range.select();
    } else {
      cov_uv2rop2ev.b[26][1]++;
    }
  }
}

function select(element) {
  cov_uv2rop2ev.f[9]++;
  cov_uv2rop2ev.s[66]++;

  if ((cov_uv2rop2ev.b[28][0]++, element) && (cov_uv2rop2ev.b[28][1]++, element.innerText) && (cov_uv2rop2ev.b[28][2]++, element.innerText.length === 0)) {
    cov_uv2rop2ev.b[27][0]++;
    cov_uv2rop2ev.s[67]++;
    element.focus();
    cov_uv2rop2ev.s[68]++;
    return;
  } else {
    cov_uv2rop2ev.b[27][1]++;
  }

  cov_uv2rop2ev.s[69]++;

  if ((cov_uv2rop2ev.b[30][0]++, window.getSelection) && (cov_uv2rop2ev.b[30][1]++, document.createRange)) {
    cov_uv2rop2ev.b[29][0]++;
    cov_uv2rop2ev.s[70]++;

    if (element) {
      cov_uv2rop2ev.b[31][0]++;
      cov_uv2rop2ev.s[71]++;
      element.focus();
    } else {
      cov_uv2rop2ev.b[31][1]++;
    }

    var range = (cov_uv2rop2ev.s[72]++, document.createRange());
    cov_uv2rop2ev.s[73]++;

    if (element) {
      cov_uv2rop2ev.b[32][0]++;
      cov_uv2rop2ev.s[74]++;
      range.selectNodeContents(element);
    } else {
      cov_uv2rop2ev.b[32][1]++;
    }

    var sel = (cov_uv2rop2ev.s[75]++, window.getSelection());
    cov_uv2rop2ev.s[76]++;

    if (sel) {
      cov_uv2rop2ev.b[33][0]++;
      cov_uv2rop2ev.s[77]++;
      sel.removeAllRanges();
      cov_uv2rop2ev.s[78]++;
      sel.addRange(range);
    } else {
      cov_uv2rop2ev.b[33][1]++;
    }
  } else {
    cov_uv2rop2ev.b[29][1]++;
    cov_uv2rop2ev.s[79]++;

    if (document.selection) {
      cov_uv2rop2ev.b[34][0]++;

      var _range2 = (cov_uv2rop2ev.s[80]++, document.selection.createRange());

      cov_uv2rop2ev.s[81]++;

      _range2.moveToElementText(element);

      cov_uv2rop2ev.s[82]++;

      _range2.select();
    } else {
      cov_uv2rop2ev.b[34][1]++;
    }
  }
}

export var focusElement = (cov_uv2rop2ev.s[83]++, {
  select: select,
  end: end,
  wrapSpan: wrapSpan,
  copyBoundingClientRect: copyBoundingClientRect
});
cov_uv2rop2ev.s[84]++;
export var preventPasteFile = function preventPasteFile(e, beforeHandler) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_uv2rop2ev.b[35][0]++, {}),
      _ref$noLineBreak = _ref.noLineBreak,
      noLineBreak = _ref$noLineBreak === void 0 ? (cov_uv2rop2ev.b[36][0]++, true) : _ref$noLineBreak,
      _ref$convertBr = _ref.convertBr,
      convertBr = _ref$convertBr === void 0 ? (cov_uv2rop2ev.b[37][0]++, ' ') : _ref$convertBr;

  cov_uv2rop2ev.f[10]++;
  var text = (cov_uv2rop2ev.s[85]++, ((cov_uv2rop2ev.b[38][0]++, e.clipboardData) || (cov_uv2rop2ev.b[38][1]++, window.clipboardData)).getData('text/plain')); // 删除复制的换行符号

  cov_uv2rop2ev.s[86]++;

  if ((cov_uv2rop2ev.b[40][0]++, noLineBreak) && (cov_uv2rop2ev.b[40][1]++, text)) {
    cov_uv2rop2ev.b[39][0]++;
    cov_uv2rop2ev.s[87]++;

    if (typeof convertBr === 'function') {
      cov_uv2rop2ev.b[41][0]++;
      cov_uv2rop2ev.s[88]++;
      text = convertBr(text).replace(/([\t\n\f\r\v])+/g, ' ');
    } else {
      cov_uv2rop2ev.b[41][1]++;
      cov_uv2rop2ev.s[89]++;
      text = text.replace(/([\t\n\f\r\v])+/g, convertBr);
    }
  } else {
    cov_uv2rop2ev.b[39][1]++;
  }

  cov_uv2rop2ev.s[90]++;
  e.preventDefault();
  cov_uv2rop2ev.s[91]++;

  if (beforeHandler) {
    cov_uv2rop2ev.b[42][0]++;
    cov_uv2rop2ev.s[92]++;
    beforeHandler(text);
  } else {
    cov_uv2rop2ev.b[42][1]++;
  }

  cov_uv2rop2ev.s[93]++;
  document.execCommand('insertText', false, text);
};
cov_uv2rop2ev.s[94]++;
export var parsePxToNumber = function parsePxToNumber(str) {
  cov_uv2rop2ev.f[11]++;
  cov_uv2rop2ev.s[95]++;
  return Number(str.replace(/\s+|px/gi, ''));
};
cov_uv2rop2ev.s[96]++;
export var addResizeObserver = function addResizeObserver(el, handler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_uv2rop2ev.b[43][0]++, {});
  cov_uv2rop2ev.f[12]++;

  var _ref2 = (cov_uv2rop2ev.s[97]++, options),
      direction = _ref2.direction,
      timer = _ref2.timer;

  var _ref3 = (cov_uv2rop2ev.s[98]++, throttle(handler, timer)),
      _ref4 = _slicedToArray(_ref3, 2),
      throttleHandler = _ref4[0],
      cleanTimer = _ref4[1];

  var h = (cov_uv2rop2ev.s[99]++, throttleHandler);
  var lastWidth;
  var lastHeight;
  cov_uv2rop2ev.s[100]++;

  if (window.ResizeObserver) {
    cov_uv2rop2ev.b[44][0]++;
    cov_uv2rop2ev.s[101]++;

    if (direction) {
      cov_uv2rop2ev.b[45][0]++;
      cov_uv2rop2ev.s[102]++;
      lastWidth = el.clientWidth;
      cov_uv2rop2ev.s[103]++;
      lastHeight = el.clientHeight;
      cov_uv2rop2ev.s[104]++;

      h = function h(entry) {
        cov_uv2rop2ev.f[13]++;

        var _ref5 = (cov_uv2rop2ev.s[105]++, entry[0].contentRect),
            width = _ref5.width,
            height = _ref5.height;

        cov_uv2rop2ev.s[106]++;

        if ((cov_uv2rop2ev.b[47][0]++, width) && (cov_uv2rop2ev.b[47][1]++, direction === 'x')) {
          cov_uv2rop2ev.b[46][0]++;
          cov_uv2rop2ev.s[107]++;

          if (lastWidth !== width) {
            cov_uv2rop2ev.b[48][0]++;
            cov_uv2rop2ev.s[108]++;
            throttleHandler(entry);
          } else {
            cov_uv2rop2ev.b[48][1]++;
          }
        } else {
          cov_uv2rop2ev.b[46][1]++;
          cov_uv2rop2ev.s[109]++;

          if (direction === 'y') {
            cov_uv2rop2ev.b[49][0]++;
            cov_uv2rop2ev.s[110]++;

            if ((cov_uv2rop2ev.b[51][0]++, height) && (cov_uv2rop2ev.b[51][1]++, lastHeight !== height)) {
              cov_uv2rop2ev.b[50][0]++;
              cov_uv2rop2ev.s[111]++;
              throttleHandler(entry);
            } else {
              cov_uv2rop2ev.b[50][1]++;
            }
          } else {
            cov_uv2rop2ev.b[49][1]++;
            cov_uv2rop2ev.s[112]++;

            if ((cov_uv2rop2ev.b[53][0]++, width) && (cov_uv2rop2ev.b[53][1]++, height)) {
              cov_uv2rop2ev.b[52][0]++;
              cov_uv2rop2ev.s[113]++;
              throttleHandler(entry, {
                x: lastWidth !== width,
                y: lastHeight !== height
              });
            } else {
              cov_uv2rop2ev.b[52][1]++;
            }
          }
        }

        cov_uv2rop2ev.s[114]++;
        lastWidth = width;
        cov_uv2rop2ev.s[115]++;
        lastHeight = height;
      };
    } else {
      cov_uv2rop2ev.b[45][1]++;
    }

    var observer = (cov_uv2rop2ev.s[116]++, new ResizeObserver(h));
    cov_uv2rop2ev.s[117]++;
    observer.observe(el);
    cov_uv2rop2ev.s[118]++;
    return function () {
      cov_uv2rop2ev.f[14]++;
      cov_uv2rop2ev.s[119]++;

      if (observer) {
        cov_uv2rop2ev.b[54][0]++;
        cov_uv2rop2ev.s[120]++;
        observer.disconnect();
      } else {
        cov_uv2rop2ev.b[54][1]++;
      }

      cov_uv2rop2ev.s[121]++;
      cleanTimer(_this2);
      cov_uv2rop2ev.s[122]++;
      observer = null;
    };
  } else {
    cov_uv2rop2ev.b[44][1]++;
  }

  cov_uv2rop2ev.s[123]++;
  window.addEventListener('resize', throttleHandler);
  cov_uv2rop2ev.s[124]++;
  return function () {
    cov_uv2rop2ev.f[15]++;
    cov_uv2rop2ev.s[125]++;
    window.removeEventListener('resize', handler);
    cov_uv2rop2ev.s[126]++;
    cleanTimer();
  };
};